module.exports = __webpack_public_path__ + "static/media/item_46_1.06a85596.jpg";